import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { TreatmentPage } from "../components/medskin/TreatmentPage";
import { TREATMENTS_CONTENT } from "../lib/treatments-data";

const TIMMA = "https://timma.no/salong/medskin-by";

export default function TreatmentRoute() {
  const { slug } = useParams();
  const data = TREATMENTS_CONTENT[slug];

  useEffect(() => {
    if (!data && typeof window !== "undefined") {
      window.location.replace(TIMMA);
    }
  }, [data]);

  if (!data) return null;
  return <TreatmentPage data={data} />;
}
